// extracted by mini-css-extract-plugin
export default {"imageWrapper":"oP-z","hovered":"pP-z","hoverImage":"qP-z","mainImage":"rP-z","imageNoBackground":"sP-z","fullSizeImage":"tP-z"};